import cookies from "js-cookie";

export const languages = [
  {
    code: "fr",
    name: "Francais",
    country_code: "fr",
  },
  {
    code: "en",
    name: "English",
    country_code: "gb",
  },
];

export const currentLanguageCode = cookies.get("i18next") || "fr";
export const currentLanguage = languages.find(
  (l) => l.code === currentLanguageCode
);
